var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgSearchBlkRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415.75 415.75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,311.81 H 311.81 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 415.75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.82 100.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-36.759 0-66.663 29.906-66.663 66.662 0 36.759 29.904 66.663 66.663 66.663 36.756 0 66.662-29.904 66.662-66.663 0-36.756-29.906-66.662-66.662-66.662m0 148.14c-44.928 0-81.477-36.55-81.477-81.477 0-44.925 36.549-81.476 81.477-81.476s81.477 36.551 81.477 81.476c0 44.927-36.549 81.477-81.477 81.477"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.813 103.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.566 0.634-1.538 0.673-2.139 0.071l-28.73-28.727c-0.578-0.577-0.578-1.517 0-2.095l8.382-8.379c0.58-0.58 1.516-0.58 2.094 0l28.733 28.728c0.602 0.604 0.563 1.579-0.074 2.142-2.918 2.586-5.68 5.342-8.266 8.26"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlkRgb);
export default __webpack_public_path__ + "static/media/Search_BLK_RGB.6cf1857b04c778329e3e950f4f2ba89a.svg";
export { ForwardRef as ReactComponent };